import { CoreApi } from "../core/CoreApi";
import { API_ENDPOINTS } from "@libs/request/endpoints_helper";

class WishlistRequest extends CoreApi {
  list(input = {}) {
    return this.http
      .get(API_ENDPOINTS.listWishlist, { params: input })
      .then((res) => res.data);
  }
  wishItem(id) {
    return this.http
      .get(`${API_ENDPOINTS.listWishitemView}/${id}`)
      .then((res) => res.data);
  }
  wishItemShared(id) {
    return this.http
      .get(`${API_ENDPOINTS.listWishitemShared}/${id}`)
      .then((res) => res.data);
  }
  view(input = {}) {
    return this.http
      .get(API_ENDPOINTS.OFFER, { params: input })
      .then((res) => res.data);
  }

  create(input = {}) {
    return this.http
      .post(API_ENDPOINTS.createWishlist, input)
      .then((res) => res.data);
  }
  deleteWishlist(id) {
    return this.http
      .post(`${API_ENDPOINTS.DeleteWishlist}/${id}`)
      .then((res) => res.data);
  }
  userWishlistUpdate(id, title) {
    return this.http
      .post(`${API_ENDPOINTS.userWishlistUpdate}/${id}`, { title: title })
      .then((res) => res.data);
  }
  setItemWishlist(id, uuid) {
    const input = {
      wishlist_id: id,
      offer_id: uuid,
    };
    return this.http
      .post(API_ENDPOINTS.addwishlistItem, input)
      .then((res) => res.data);
  }
  createShared(id) {
    const input = {
      wishlist_id: id,
    };
    return this.http
      .post(API_ENDPOINTS.createShared, input)
      .then((res) => res.data);
  }
  removeItemWishlist(id) {
    const input = {
      offer_id: id,
    };
    return this.http
      .post(API_ENDPOINTS.removeItemWishlist, input)
      .then((res) => res.data);
  }
}
export const WishlistService = new WishlistRequest("auth");
